<template>
<div>
    <div class="row cart-product">
      <div class="col-xs-7">
        <div >
          <h5 class="product-name">
            {{ cart_item.name }}
            <span @click="confirm_delete(cart_item.id)">
              <img height="18px" src="/static/24-em-cross.png">
            </span>
          </h5>
        </div>
      </div>

      <div class="col-xs-5 text-right">
         <select class="cart-item--quantity" v-model="cart_item.quantity" @change="update_quantity({cart_id: cart_item.id, quantity: cart_item.quantity})">
          <option v-for="n in 100">{{ n }}</option>
        </select>
        <span class="product-price">{{ cart_item.price_final | formatCurrency(currency) }}</span>
      </div>
    </div>

    <div class="row">
      <template v-for="modifier in cart_item.modifiers">
        <div class="col-xs-12 ">
          <p>
            <small class="sub-product__item--name">{{ modifier.type === 'FIXED_DECREASE' ? '-' : '+'}} {{ modifier.name }}</small>
            <small class="sub-product-price"> {{ modifier.amount | formatCurrency(currency) }}</small>
          </p>
        </div>
      </template>
    </div>

<!--   <ul class="list-unstyled">
    <li class="cart-product">
      <h5 class="product-name">
        {{ cart_item.name }}
        <span @click="confirm_delete(cart_item.id)"><img height="15px" src="/static/24-em-cross.png"></span>
      </h5>
      <div class="product-quantity">
        <select class="cart-item--quantity" v-model="cart_item.quantity" @change="update_quantity({cart_id: cart_item.id, quantity: cart_item.quantity})">
          <option v-for="n in 10">{{ n }}</option>
        </select>
        <p class="product-price">{{ cart_item.price_final | formatCurrency(currency) }}</p>
      </div>

    </li>
    <ul class="list-unstyled modifiers-list" v-for="modifier in cart_item.modifiers">
      <li class="" v-if="modifier.type === 'FIXED_INCREASE'"> <span class="">{{ modifier.type === 'FIXED_INCREASE' ? '+': '-' }} </span> <span class="">{{ modifier.name }}</span> {{ modifier.amount | formatCurrency(currency) }}</li>
    </ul>
  </ul> -->
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    props: ['cart_item', 'currency'],

    methods: {
      ...mapActions([
        'delete_item',
        'update_quantity',
        'apply_coupon',
        'remove_coupon',
      ]),

      confirm_delete (cart_id) {
        this.delete_item(cart_id);
      },
    }
  };
</script>



// WEBPACK FOOTER //
// summary-item.vue?eb2a00f4